module.exports = __webpack_public_path__ + "img/Banner-Sijakon-Proyek-Landscape.17484ce6.png";